module.exports = __webpack_public_path__ + "img/fs-banner-catalogue.df75e07c.svg";